import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { NotificationService } from '../services/notification.service';
import { AuthStore } from '../store/auth.store';

const AUTH_ENDPOINTS = [
  '/api/auth/login',
  '/api/auth/callback',
  '/api/auth/me',
  '/api/auth/logout',
  '/api/auth/change-password',
];

const DOCS_ENDPOINT_PREFIX = '/api/docs/';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const notification = inject(NotificationService);
  const authStore = inject(AuthStore);

  const isApiRequest = req.url.startsWith('/api/');
  const request = isApiRequest ? req.clone({ withCredentials: true }) : req;
  const isAuthEndpoint = AUTH_ENDPOINTS.some((ep) => req.url.startsWith(ep));
  const isDocsEndpoint = req.url.startsWith(DOCS_ENDPOINT_PREFIX);

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      if (!isAuthEndpoint) {
        if (error.status === 401) {
          authStore.clearSession();
          notification.showError('Your session has expired. Please sign in again.');
          const currentUrl = router.url;
          router.navigate(['/login'], {
            queryParams: { returnUrl: currentUrl },
          });
        } else if (error.status === 403 && !isDocsEndpoint) {
          notification.showError("You don't have permission to access that resource.");
          router.navigate(['/dashboard']);
        }
      }
      return throwError(() => error);
    })
  );
};
